import { Typography } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';

interface BodyMainProps extends PropsWithChildren<{ className?: string }> {
  'data-test'?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const BodyMain: React.FC<BodyMainProps> = ({ className, children, style, 'data-test': dataTest }) => (
  <Typography component="span" className={className} style={style} variant="body1" data-test={dataTest}>
    {children}
  </Typography>
);

export default BodyMain;
